import { useSettings } from "../../contexts/Settings";
import { useVideoSource } from "../../contexts/VideoSource";
import { ModalLocation } from "../../types/modalLocation";
import { Modal } from "../Modal";
import { Row } from "../Modal/Row";

export const ResolutionsModal = () => {
  const { setShowResolutionsModal, showResolutionsModal } = useSettings();
  const { qualityLevels, currentQualityLevel, setQualityLevel } =
    useVideoSource();

  const closeSelf = () => {
    setShowResolutionsModal(false);
  };

  const selectQualityLevel = (id: number) => {
    closeSelf();

    if (setQualityLevel !== undefined) {
      setQualityLevel(id);
    }
  };

  return (
    <Modal
      modalLocation={ModalLocation.bottomRight}
      show={showResolutionsModal}
      closeSelf={closeSelf}
    >
      {qualityLevels?.map(({ id, label }) => {
        const onClick = () => {
          selectQualityLevel(id);
        };

        return (
          <Row
            selected={currentQualityLevel?.id === id}
            weakSelection={currentQualityLevel?.isAuto ?? false}
            onClick={onClick}
            key={id}
            label={label}
          />
        );
      })}
      <Row
        selected={currentQualityLevel?.isAuto ?? false}
        label="auto"
        onClick={() => {
          selectQualityLevel(-1);
        }}
      />
    </Modal>
  );
};
